import { useState, useMemo } from "react";
import TextInput from "../components/ui/Input/TextInput";
import useFetch from "../hooks/useFetch";
import styles from "../components/EntityAddUpdateForm/EntityAddUpdateForm.module.css";
import DashboardSidebar from "../components/DashboardSidebar";

const AddStore: React.FC = () => {
  const storedUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);

  const currentRole = storedUser?.current_role;
  const userId = storedUser?.id;
  const userEmail = storedUser?.email;
  const user_Firstname = storedUser?.first_name;
  const user_Lastname = storedUser?.last_name;

  const [storeName, setStoreName] = useState<string>("");
  const [studioOrgName, setStudioOrgName] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { fetchData, isLoading: loading } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/stores/add`,
    method: "POST",
  });

  const handleAddStore = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    if (!storeName.trim()) {
      setErrorMessage("Store name is required.");
      return;
    }

    if (!studioOrgName.trim()) {
      setErrorMessage("Studio organization name is required.");
      return;
    }

    const payload = {
      user_storeowner_id: userId,
      email: userEmail,
      first_name: user_Firstname,
      last_name: user_Lastname,
      store_name: storeName.trim(),
      studio_organization_name: studioOrgName.trim(),
    };

    const result = await fetchData(payload);

    if (result?.success) {
      setSuccessMessage("Store created successfully!");
      setStoreName("");
      setStudioOrgName("");

      // Update localStorage with the new store
      const updated = { ...storedUser };
      if (!updated.stores) {
        updated.stores = [];
      }
      updated.stores.push(result?.data?.store);
      localStorage.setItem("user", JSON.stringify(updated));
      window.dispatchEvent(new Event("user-updated"));
    } else {
      const raw = result?.errors?.length
        ? result.errors.map((e: any) => Object.values(e).join(", ")).join(", ")
        : result?.message || "Failed to create store.";
      setErrorMessage(raw.replace(/^Error in \w+:\s*/i, ""));
    }
  };

  return (
    <div className="page-wrapper-columnwise">
      {currentRole !== 1 && <DashboardSidebar />}

      <div className="content-columnwise">
        <div className="center-container">
          <form onSubmit={handleAddStore} className={styles.entityChangePasswordForm}>
            <h2 className="form-title">Add New Store</h2>
            <h5>Create a new store</h5>

            <TextInput
              label="Store Name"
              placeholder="Enter store name"
              value={storeName}
              onChange={(e) => {
                setErrorMessage(null);
                setSuccessMessage(null);
                setStoreName(e.target.value);
              }}
            />

            <TextInput
              label="Studio Organization Name"
              placeholder="Enter studio organization name"
              value={studioOrgName}
              onChange={(e) => {
                setErrorMessage(null);
                setSuccessMessage(null);
                setStudioOrgName(e.target.value);
              }}
            />

            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <div className={styles.buttonContainer}>
              <button
                type="submit"
                className={styles.entityAddUpdateForm__submitbtn}
                disabled={loading}
              >
                {loading ? "Creating..." : "Add Store"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStore;
